import { Component } from 'react'
import Modal from '.'
import PopupModal from './PopupModal'
import MedicationForm from '../forms/popups/MedicationForm'

interface Medication {
  id: string
  resident: string
  name: string
  // Define other properties
}

interface EditMedicationModalProps {
  fields: Medication
  isOpen: boolean
  updateItem: (data: any) => void
  fetchList: (list: string, options?: any) => void
  showToast: (options: { title: string }) => void
}

export class EditMedicationModal extends Component<EditMedicationModalProps> {
  handleSubmit = () => {
    const { updateItem, fetchList, fields, showToast } = this.props

    updateItem({
      onComplete: () => {
        showToast({ title: 'Updated a Medication' })
        fetchList('medications', { filters: { resident: fields.resident } })
      },
      url: `list/medications/${fields.id}`,
    })
  }

  render() {
    const { fields, isOpen, ...formProps } = this.props

    if (!fields || !isOpen) return null

    return (
      <PopupModal
        confirmText="Save"
        list={fields.name || 'Medication'}
        onConfirm={this.handleSubmit}
        {...formProps}
        type="edit"
      >
        <MedicationForm
          fields={fields}
          formId={MODAL_ID}
          type="edit"
          medicationsList={undefined}
        />
      </PopupModal>
    )
  }
}

const MODAL_ID = 'editMedication'

export default Modal(EditMedicationModal, MODAL_ID)
